module.exports = __webpack_public_path__ + "images/directlease15cce1e67e929a509595b1348e53d9de.png";